import type { AdminRouterContext } from '@/lib/router-context'
import { AdminPageHeader } from '@/components/patterns/admin-page'
import NotificationRecipientForm from '@/components/forms/NotificationRecipientForm'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { BellPlus } from 'lucide-react'

export function beforeCreateNotificationRecipient({
  context,
}: {
  context: { ability: Pick<AdminRouterContext['ability'], 'can'> }
}): void {
  if (!context.ability.can('create', 'notification-recipients')) throw notFound()
}

export function notificationRecipientCreateLoader(): { isReadOnly: false } {
  return { isReadOnly: false }
}

export const Route = createFileRoute('/_authenticated/$orgId/settings/notifications/create')({
  beforeLoad: beforeCreateNotificationRecipient,
  loader: notificationRecipientCreateLoader,
  component: RouteComponent,
})

export function RouteComponent() {
  return (
    <div className="space-y-4 max-w-4xl">
      <AdminPageHeader icon={BellPlus} title="Add Notification Recipient" />
      <NotificationRecipientForm />
    </div>
  )
}
